import { Box, Skeleton } from '@mantine/core'

import classes from './FundraiserCard.module.scss'

export function FundraiserCardSkeleton() {
  return (
    <Box data-testid="fundraiser-card-skeleton">
      <Skeleton height={140} className={classes.BannerSkeleton} />
      <Skeleton height={24} width="75%" />
      <Skeleton height={4} className={classes.ProgressBarSkeleton} />
      <Skeleton height={20} width="60%" />
    </Box>
  )
}
